(function ($) {
  $(".accordion-item__body").hide();
  $(".accordion-item__body").attr("aria-hidden", "true");
  $("a.accordion-item__title-container").addClass(
    "accordion-item__title-container--toggle-off"
  );

  /** Adding aria-control div id**/

  var itemNum = 1;
  $(".accordion-item").each(function () {
    var accordionTriggerID = "accordiontrigger-" + itemNum;
    var accordionIDName = "accordionietm-" + itemNum;
    $(this)
      .find(".accordion-item__title-container")
      .attr("id", accordionTriggerID)
      .attr("aria-controls", accordionIDName);
    $(this)
      .find(".accordion-item__body")
      .attr("aria-labelledby", accordionTriggerID)
      .attr("id", accordionIDName);
    itemNum++;
  });

  $(".accordion-item__title-container").on("click", function () {
    var ele = $(this);
    var onlyOneShown = false;
    if (ele.closest(".js-only-one-accordion-shown").length) {
      onlyOneShown = true;
    }

    // Prevent clicks upon animation

    if ($(".accordion-item__body :animated").length) return false;

    if ($(this).hasClass("accordion-item__title-container--toggle-on")) {
      $(this)
        .parent()
        .next(".accordion-item__body")
        .attr("aria-hidden", "true")
        .slideUp();
      $(this).removeClass("accordion-item__title-container--toggle-on");
      $(this).addClass("accordion-item__title-container--toggle-off");
      $(this).attr("aria-expanded", "false");
    } else {
      if (onlyOneShown) {
        $(".accordion-item__body").slideUp();
      }
      $(this)
        .parent()
        .next(".accordion-item__body")
        .attr("aria-hidden", "false")
        .slideDown();
      if (onlyOneShown) {
        $("a.accordion-item__title-container").removeClass(
          "accordion-item__title-container--toggle-on"
        );
        $("a.accordion-item__title-container").addClass(
          "accordion-item__title-container--toggle-off"
        );
      }
      $(this).removeClass("accordion-item__title-container--toggle-off");
      $(this).addClass("accordion-item__title-container--toggle-on");
      $(this).attr("aria-expanded", "true");
    }

    return false;
  });
})($);
